import { render, staticRenderFns } from "./year-group-report.vue?vue&type=template&id=122b26f9&scoped=true"
import script from "./year-group-report.vue?vue&type=script&lang=js"
export * from "./year-group-report.vue?vue&type=script&lang=js"
import style0 from "./year-group-report.vue?vue&type=style&index=0&id=122b26f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122b26f9",
  null
  
)

export default component.exports